<template>
  <div class="container bg1">
    <h3>Add new stock details</h3>
    <div class="col-md-8 col-md-offset-2">
      <form v-on:submit.prevent>
        <div class="form-group">
          <label for="name">Name *</label>
          <input
            type="text"
            class="form-control"
            v-model="add.name"
            id="name"
          >
        </div>
        <div class="form-group">
          <label for="code">Code *</label>
          <input
            type="text"
            class="form-control"
            v-model="add.code"
            id="code"
          >
        </div>
        <div class="form-group">
          <label for="code">NSE Code</label>
          <input
            type="text"
            class="form-control"
            v-model="add.nseCode"
            id="code"
          >
        </div>
        <div class="form-group">
          <label for="code">BSE Code</label>
          <input
            type="text"
            class="form-control"
            v-model="add.bseCode"
            id="code"
          >
        </div>
        <div class="form-group">
          <label for="description">Description *</label>
          <input
            type="text"
            class="form-control"
            v-model="add.description"
            id="description"
          >
        </div>
        <!-- <div class="form-group">
          <label for="target">Target </label>
          <input type="number" style="width:100%" class="form-control" v-model="add.target" id="target">
        </div>
        <div class="form-group">
          <label for="quantity">Quantity </label>
          <input type="number" style="width:100%" class="form-control" v-model="add.quantity" id="quantity">
        </div>
        <div class="form-group">
          <label for="percentage">Percentage </label>
          <input type="number" style="width:100%" class="form-control" v-model="add.percentage" id="percentage">
        </div> -->
        <div class="form-group">
          <label for="reportLink">Enter Report Link </label>
          <input
            type="text"
            class="form-control"
            v-model="add.reportLink"
            id="reportLink"
          >
        </div>

        <!-- <div class="form-group">
          <label for="reportLink">Upload Report </label>
          <input
            type="file"
            class="form-control"
            @change="fileChange"
          >
        </div> -->

        <!--
        <div class="form-group">
          <label for="buyDate">Buy Date </label>
          <br>
          <v-date-picker v-model="add.buy_date" :landscape="true" :reactive="reactive" color="teal accent-4"></v-date-picker>
        </div>
        <div class="form-group">
          <label for="sellDate">Sell Date </label>
          <br>
          <v-date-picker v-model="add.sell_date" :landscape="true" :reactive="reactive" color="teal accent-4"></v-date-picker>
        </div> -->

        <button
          type="submit"
          @click="save"
          class="pa-3 admin_button"
        >Submit</button>
      </form>
    </div>
  </div>
</template>

<script>
  import lb from "../../util/lb";
  import { mapGetters } from "vuex";

  export default {
    name: "AddNewStock",
    computed: {
      ...mapGetters(["user"])
    },
    mounted() {
      if (!this.user) {
        this.$router.push("/login");
        return;
      }
      if (this.user.admin != 999) {
        this.$router.push("/myaccount");
        return;
      }
      lb.get("/api/Stocks/getexchangelist").then(({ data }) => {
        this.exchangeList = data;
      });
    },
    data() {
      return {
        exchangeList: [],
        reactive: true,
        add: {
          name: null,
          quantity: 0,
          percentage: 0,
          description: null,
          exchange: null,
          buy_date: null,
          sell_date: null,
          reportLink: null,
          target: 0
        }
      };
    },
    methods: {
      // fileChange(event) {
      //   const file = event.target.files[0];
      //   if (!file) {
      //     return;
      //   }
      //   const fd = new FormData();
      //   fd.append("0", file);

      //   lb.post("/api/GWSUsers/uploadReport", fd)
      //     .then(({ data }) => {
      //       this.$toasted.show("Report Uploaded!", {
      //         duration: 2000,
      //         position: "bottom-right"
      //       });
      //     })
      //     .catch(() => {
      //       this.$toasted.error("Some Error has Occured while uploading link", {
      //         duration: 2000,
      //         position: "bottom-right"
      //       });
      //     });
      // },
      save() {
        lb.post("/api/Stocks/", this.add)
          .then(({ data }) => {
            this.add = {
              name: null,
              quantity: 0,
              percentage: 0,
              target: 0,
              description: null,
              exchange: null,
              buy_date: null,
              sell_date: null,
              reportLink: null
            };
          })
          .then(() => {
            this.$toasted.show("Data Saved", {
              duration: 2000,
              position: "bottom-right"
            });
          })
          .catch(() => {
            this.$toasted.error("Some Error has Occured", {
              duration: 2000,
              position: "bottom-right"
            });
          });
      }
    }
  };
</script>

<style lang="scss" scoped>
  h3 {
    text-align: center;
  }
  .admin_button {
    background-color: #31cc9a;
    color: #fff;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/AddNewStock.vue